<template>
  <div>
    <div class="alert alert-info p-3 mb-0">
      <p class="fs-5 fw-bold mb-2">
        {{ this.$t('SmartMatch.packageQuestion', { description }) }}
      </p>
      <p class="mb-3">
        {{ this.$t('SmartMatch.missingPackage') }}
      </p>
      <div class="d-flex flex-wrap gap-2">
        <button
          class="btn btn-sm btn-outline-secondary"
          type="button"
          v-for="supportedPackage in supportedPackages"
          :key="supportedPackage"
          @click="$emit('add-package', supportedPackage)"
        >
          {{ supportedPackage }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import messages from 'locales/SmartMatch';

export default {
  name: 'SmartMatchPackageHint',
  props: {
    description: String,
    supportedPackages: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add-package'],
  i18n: { messages },
};
</script>
